var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9095 12.0426L15.7558 10.4964C15.9064 10.4146 16 10.2621 16 10.0984V7.00555C16 6.84205 15.9064 6.68935 15.7558 6.60748L12.9095 5.06131C12.759 4.97944 12.5717 4.97968 12.4212 5.06131L9.57491 6.60748C9.42437 6.68935 9.33072 6.84181 9.33072 7.00555V12.5321L7.3349 13.6161L5.33906 12.5321V10.3634L7.3349 9.27942L8.6515 9.9944V8.53971L7.57907 7.95726C7.50508 7.91716 7.42062 7.89603 7.3349 7.89603C7.24916 7.89603 7.16471 7.91716 7.09071 7.95726L4.24418 9.50366C4.09364 9.58554 4 9.73799 4 9.90173V12.9943C4 13.1578 4.09364 13.3105 4.24418 13.3924L7.09046 14.9388C7.241 15.0204 7.42802 15.0204 7.57882 14.9388L10.4251 13.3926C10.5756 13.3107 10.6693 13.158 10.6693 12.9945V7.46796L10.7052 7.44851L12.6651 6.38396L14.6609 7.4682V9.63667L12.6651 10.7209L11.3505 10.0069V11.4616L12.4209 12.0433C12.5715 12.1249 12.7587 12.1249 12.9093 12.0433L12.9095 12.0426Z",
    fill: "url(#paint0_linear_4085_1518)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4085_1518",
    x1: 5.02011,
    y1: 13.4166,
    x2: 14.89,
    y2: 5.76814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A726C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScan);
export default __webpack_public_path__ + "static/media/polygonScan.427350d955d5c889fb9d3d25db6500ab.svg";
export { ForwardRef as ReactComponent };